import { render, staticRenderFns } from "./storageAge.vue?vue&type=template&id=cd98243c&"
import script from "./storageAge.vue?vue&type=script&lang=js&"
export * from "./storageAge.vue?vue&type=script&lang=js&"
import style0 from "./storageAge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports